import { css } from 'styled-components';
import { propStyling } from '../../../shared/propStyling';
import { tombac } from '../../../shared/tombac';
export const selectCss = css(["all:initial;display:inline-block;position:relative;width:", ";height:", ";", ""], tombac.space(20), _ref => {
  let {
    size
  } = _ref;
  return tombac.space(size === 's' ? 4 : 5);
}, propStyling);
//# sourceMappingURL=selectCss.js.map